import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "../components/site/Logo";
import { Footer } from "../components/site/FinalCta";
import { Reveal } from "../components/site/motion";
import { IMPRESSUM, DATENSCHUTZ } from "../content/legal";

const PAGES = { impressum: IMPRESSUM, datenschutz: DATENSCHUTZ };

export default function LegalPage({ page }) {
  const data = PAGES[page];
  useEffect(() => {
    document.title = `${data.title} – GRÜNWIRBEL`;
    window.scrollTo(0, 0);
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
  }, [data]);

  return (
    <>
      <header className="sticky top-0 z-50 border-b border-[#E2DDD0] bg-[#FBF9F4]/90 py-3 backdrop-blur-md">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-5 sm:px-8">
          <Link to="/" data-testid="legal-logo-link" aria-label="Zur Startseite"><Logo /></Link>
          <Link to="/" data-testid="legal-back-link" className="link-underline flex items-center gap-2 text-sm font-medium text-[#1E5631]">
            <ArrowLeft className="h-4 w-4" /> Zur Startseite
          </Link>
        </div>
      </header>
      <main data-testid={`legal-page-${page}`} className="mx-auto max-w-3xl px-5 pb-24 pt-16 sm:px-8 md:pt-24">
        <Reveal>
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-[#C86D51]">Rechtliches</p>
          <h1 className="font-display text-4xl font-medium tracking-[-0.02em] text-[#1B281E] sm:text-5xl lg:text-6xl">{data.title}</h1>
          <p className="mt-4 text-sm text-[#4B5B4E]">Stand: Oktober 2026</p>
        </Reveal>
        <div className="mt-14 space-y-10">
          {data.sections.map((s) => (
            <section key={s.h}>
              <h2 className="font-display text-2xl text-[#1B281E]">{s.h}</h2>
              <div className="mt-3 space-y-3 leading-relaxed text-[#4B5B4E]">
                {s.p.map((t) => <p key={t}>{t}</p>)}
              </div>
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </>
  );
}
